import React from 'react';
import { Link } from 'react-router-dom'
import logo from '../../../assets/images/logo.png'


const AdminHeaderView = (props) => {
    return (
        <>
            
                <div className="container-fluid">
                    <nav className="cc-header_nav navbar">
                        <Link to="/home" className="navbar-brand">
                            <img src={logo} alt="logo image" className="cc-logo" />
                        </Link>
                        {/* <a className="navbar-brand" href="#"><img src={logo} alt="logo image" className="cc-logo" /></a> */}
                         {props.first_name && localStorage.getItem('token') ?
                            <li className='mobile_hide' style={{listStyleType: "none"}}>Welcome {props.first_name} {props.last_name}</li>
                            :
                            null
                         }
                        <ul className=" ml-auto cc-header_contactlist">
                            {props.id && localStorage.getItem('token') ?
                            <li className='mobile_hide' >ID : {props.id}</li>
                            :
                            null
                            }
                            <li className='mobile_hide' ><a href="tel:+97142314828"><button type="button" className="btn  cc-phone_no"><i className="fa fa-phone" aria-hidden="true"></i> +97142314828 </button></a></li>
                            <li className='mobile_hide' ><a href="/find-jobs"><button type="button" className="btn btn-red regular">Find a Job <i className="fa fa-search" aria-hidden="true"></i></button></a></li>
                            <li className='mobile_hide' ><a href="/job-post"><button type="button" className="btn btn-red regular">Post a Job <i className="fa fa-suitcase" aria-hidden="true"></i></button></a></li>
                            <li className='mobile_hide' ><button type="button" className="btn btn-blue shape-rounded"><i className="fa fa-user button-icon" aria-hidden="true"></i></button></li>


                            <li>
                                <div className={props.manuClass} style={{overflow:'auto'}}>
                                    <button onClick={props.closeMenuBar} className="sidebarClose"><i className="fa fa-times" aria-hidden="true"></i></button>
                                    <ul onClick={props.closeMenuBar} className="cc-header_menulist">
                                        {localStorage.getItem('token') ?
                                        null
                                        :
                                        <li>
                                            <Link to="/login">Log In</Link>
                                        </li>
                                        }
                                         {localStorage.getItem('token') ?
                                        null
                                        :
                                        <li>
                                            <Link to="/user/registration">Sign-Up</Link>
                                        </li>
                                        }

                                        <li className='mobile_show' >
                                            <Link to="/find-jobs">Find Jobs</Link>
                                        </li>

                                        <li className='mobile_show' >
                                            <Link to="/job-post">Post Job</Link>
                                        </li>

                                        <li className='mobile_show' >
                                         <a href="tel:+97142314828"><i className="fa fa-phone" aria-hidden="true"></i> +97142314828</a>
                                         </li>

                                        <li>
                                            <Link to="/admin/dashboard">Admin Dashboard</Link>
                                        </li>
                                        <li>
                                            <Link to="/admin/applicants-dashboard">Applicants Dashboard</Link>
                                        </li>
                                        <li>
                                            <Link to="/admin/candidates-dashboard">Candidates Dashboard</Link>
                                        </li>

                                        <li>
                                            <Link to="/admin/customer-dashboard">Customer's Dashboard</Link>
                                        </li>
                                        <li>
                                            <Link to="/admin/interview-dashboard">Interview's Dashboard</Link>
                                        </li>
                                        

                                        {localStorage.getItem('token') ?
                                        <li onClick={props.handlelogout}>
                                            <Link >Log Out</Link>
                                        </li>
                                        :
                                        null
                                        }
                                    </ul>
                                </div>
                                <button onClick={props.showMenuBar} className="sidebarBtn" type="button">
                                    <span></span>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
  
        </>
    )
}

export default AdminHeaderView;